import { render, staticRenderFns } from "./resetPasswordLayout.vue?vue&type=template&id=541cd63c&"
import script from "./resetPasswordLayout.vue?vue&type=script&lang=js&"
export * from "./resetPasswordLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports